import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UserNotificationsQuery,
  UserNotificationsQueryVariables,
} from "./UserNotifications.generated";

export const USER_NOTIFICATIONS: TypedDocumentNode<
  UserNotificationsQuery,
  UserNotificationsQueryVariables
> = gql`
  query userNotifications(
    $notificationType: String
    $noteUuid: String
    $unreadOnly: Boolean
    $notificationDomain: String
  ) {
    userNotifications(
      notificationType: $notificationType
      noteUuid: $noteUuid
      unreadOnly: $unreadOnly
      notificationDomain: $notificationDomain
    ) {
      uuid
      type
      title
      message
      noteUuid
      actionUrl
      activeAt
      expiresAt
      dismissedAt
      extra
      isBroadcast
      createdAt
      readAt
    }
  }
`;
